import { DetailsListLayoutMode, ICommandBarItemProps, TooltipHost } from "@fluentui/react";
import { UseRazonModelo } from "./UseRazonModelo";
import { initialRazonModeloDTO, IRazonModeloDTO } from "../../../../Interfaces/auxiliar/IRazonModelo";
import themeBase from "../../../../utils/theme/themeBase";
import { PanelNuevoRazonModelo } from "./razonModeloNuevo/PanelNuevoRazonModelo";
import { useBoolean } from "@fluentui/react-hooks";
import { PanelRazonModeloEliminar } from "./razonModeloEliminar/PanelRazonModeloEliminar";
import { useState } from "react";
import { Button } from "@fluentui/react-components";
import { useIconsCatalogo } from "../../../../components/iconCatalog/common.useIconsCatalogo";
import { DeleteRegular } from "@fluentui/react-icons";
import { CabeceraTable } from "../../../../components/Table/CabeceraTable";
import { TableBaseComponent } from "../../../../components/Table/TableBaseComponent";
import IconHelper from "../../../../utils/helpers/iconHelper";
import { PanelRazonModeloFiltrar } from "./razonModeloFiltro/PanelRazonModeloFiltro";
import { PanelSincronizarRazon } from "../razon/RazonSincronizar/PanelSincronizarRazon";
import { PanelRazonModeloSync } from "./razonModeloSync/PanelRazonModeloSync";

const iconDetalleStyle: React.CSSProperties | undefined = {
   color: "#0078d4",
};

const RazonModelo = () => {
   const { Icon } = useIconsCatalogo();
   const [isOPenPanel, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
   const [isOpenSYNC, { setTrue: openPanelSYNC, setFalse: closePanelSYNC }] = useBoolean(false);

   const [openFiltrarModelo, setFiltrarModelo] = useState(false)
   const [isOpenEliminar, { setTrue: openPanelEliminar, setFalse: closePanelEliminar }] = useBoolean(false);
   const [item, setItem] = useState<IRazonModeloDTO>(initialRazonModeloDTO)
   const { items, filter, setFilter, loading, pagination, getRazonModelo, handleResetUpdate, onChangeTake, buscar, _onkeyUpSearchTable, onChangeComboFilter, onChangeSearch, filter2, resetFilter2 } = UseRazonModelo();

   const buttonLeft: ICommandBarItemProps[] = [
      // {
      //    ...IconHelper.ICON_ADD_TABLE,
      //    text: "Nuevo",
      //    onClick: () => {
      //       openPanel()
      //    },
      // },
      {
         ...IconHelper.ICON_RELOAD2,
         text: "Sincronizar",
         onClick: () => {
           openPanelSYNC()
         },
       },
      {
         ...IconHelper.ICON_RELOAD,
         text: "Actualizar",
         onClick: () => {
            handleResetUpdate()
            getRazonModelo()
         },
      }
   ];

   const buttonRight: ICommandBarItemProps[] = [
      {
         ...IconHelper.ICON_BS_FILTER,
         text: "Buscar",
         onClick: () => {
            setFiltrarModelo(true)
            getRazonModelo()
         },
      }
   ];

   function renderOpciones(item: IRazonModeloDTO) {
      return (
         <>
            <TooltipHost content={`Eliminar`}>
               <Button
                  size="large"
                  icon={<DeleteRegular />}
                  className={themeBase.classNamesIcon.iconFont}
                  style={iconDetalleStyle}
                  onClick={() => {
                     setItem(item)
                     openPanelEliminar()
                  }}
               />
            </TooltipHost>
         </>
      );
   }

   const _columns = [
      {
         key: "numeracion",
         name: "N°",
         fieldName: "numeracion",
         minWidth: 50,
         maxWidth: 50,
      },
      {
         key: "razon",
         name: "Razón",
         fieldName: "razon",
         minWidth: 300,
         maxWidth: 300,
      },
      {
         key: "modelo",
         name: "Modelo",
         fieldName: "nombre",
         minWidth: 300,
         maxWidth: 300,
      },
      {
         key: "tipoEquipo",
         name: "Tipo de Equipo",
         fieldName: "tipoEquipo",
         minWidth: 150,
         maxWidth: 150
      },
      {
         key: "opciones",
         name: "Opciones",
         minWidth: 2,
         maxWidth: 2,
         fieldName: "opciones",
         onRender: (item: IRazonModeloDTO) => renderOpciones(item)
      },
   ]

   return (
      <>
         <CabeceraTable
            Titulo={"Razón Modelo"}
            SubTitulo={"Gestión de Razón Modelo"}
         // placeholder="buscar..."
         // componentRef={onChangeSearch}
         // onKeyUp={_onkeyUpSearchTable}
         />
         {/* <pre>{JSON.stringify(,null,2)}</pre> */}
         <TableBaseComponent
            leftBar={buttonLeft}
            rigthBar={buttonRight}
            data={items}
            column={_columns}
            isLoading={loading}
            getPageSize={onChangeTake}
            pagination={pagination}
            layout={DetailsListLayoutMode.justified}
            tableSiza
         />
         <PanelRazonModeloFiltrar
            filter2={filter2}
            isOpen={openFiltrarModelo}
            onChangeComboFilter={onChangeComboFilter}
            resetFilter2={resetFilter2}
            buscar={buscar}
            onDismiss={() => setFiltrarModelo(false)}
         />
         <PanelRazonModeloSync isOpen={isOpenSYNC} onDismiss={closePanelSYNC} 
         reload={handleResetUpdate}/>
         
         <PanelNuevoRazonModelo
            isOpen={isOPenPanel}
            onDismiss={dismissPanel}
            reload={handleResetUpdate}
         />
         {isOpenEliminar && <PanelRazonModeloEliminar
            item={item}
            isOpen={isOpenEliminar}
            onDismiss={closePanelEliminar}
            reload={handleResetUpdate}
         />}


      </>
   )
}

export { RazonModelo }  